export default "__VITE_PUBLIC_ASSET__eef2fdc1__"